import { ReactNode } from 'react';
import styles from "./SigninLayout.module.scss";

interface SigninLayoutProps {
  children: ReactNode;
  title?: string;
  subtitle?: string;
  showLogo?: boolean;
}

export function SigninLayout({
  children,
  title,
  subtitle,
  showLogo = true,
}: SigninLayoutProps) {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {showLogo && (
          <div className={styles.logoSection}>
            <div className={styles.logo}>
              <img
                src={`${import.meta.env.BASE_URL}logo.png`}
                alt="Saga Soft"
              />
            </div>
          </div>
        )}

        <div className={styles.card}>
          {title && (
            <div className={styles.header}>
              <h2 className={styles.title}>{title}</h2>
              {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
            </div>
          )}

          <div className={styles.body}>{children}</div>
        </div>

        <footer className={styles.footer}>
          <p className={styles.footerText}>
            Need help?{' '}
            <a href="mailto:support@example.com" className={styles.footerLink}>
              Contact support
            </a>
          </p>
        </footer>
      </div>
    </div>
  );
}